export default {
    data() {
        return {
            visibleCount: 0,
            offsetting: 0,
            Theight: 0,
            itemHeight: 0,
            isVirtual: false,
            start: 0,
            end: 1
        };
    },
    computed: {
        data() {
            // 修改el-table加载数据逻辑
            if(this.isVirtual) {
                return this.table.tableData.slice(this.start, this.end);
            }else {
                return this.table.tableData;
            }
        }
    },
    watch: {
        'table.tableData'(value) {
            if(this.isVirtual) {
                this.handleVirtualTable(value);
            }
        }
    },
    beforeDestroy() {
        this.handleScroll = null;
    },
    created() {
        // console.log('created');
        this.isVirtual = this.$parent.$attrs['is-virtual'];
        // 开启虚拟列表需要固定列表高度，默认500
        // 可动态设置Theight
        this.Theight = this.$parent.height || 500;
        this.itemHeight = this.$parent.$attrs['item-height'] || 40;
        // 缩放浏览器时需要重新计算
        this.$nextTick(() => {
            if(this.isVirtual) {
                const scrollContainer = this.$parent.$el.querySelector('.el-table__body-wrapper');
                window.addEventListener('resize', () => {
                    // 列表数据初始化（可见条数）
                    this.visibleCount = Math.ceil(scrollContainer.clientHeight / this.itemHeight);
                    this.end = this.start + this.visibleCount;
                });
            }
        });
    },
    methods: {
        handleVirtualTable(data) {
            // console.log('handleVirtualTable', data);
            this.$nextTick(() => {
                let virtualDiv = this.$parent.$el.querySelector('#virtualDiv');
                const tableBody = this.$parent.$el.querySelector('.el-table__body');
                const scrollContainer = this.$parent.$el.querySelector('.el-table__body-wrapper');

                scrollContainer.style.overflow = 'auto';
                scrollContainer.addEventListener('scroll', this.handleScroll, true);

                // console.log('ccc', scrollContainer.style.height, this.Theight);


                this.$nextTick(() => {
                    const row = tableBody.querySelector('.el-table__row');
                    if(row) {
                        this.itemHeight = row.clientHeight;
                    }
                    // 虚拟滚动条
                    if(!virtualDiv) {
                        virtualDiv = document.createElement('div');
                        virtualDiv.id = 'virtualDiv';
                        virtualDiv.style.height = `${data.length * this.itemHeight}px`;
                        scrollContainer.appendChild(virtualDiv);

                        this.end = this.visibleCount = Math.ceil(
                            scrollContainer.clientHeight / this.itemHeight
                        );
                    }else {
                        virtualDiv.style.height = `${data.length * this.itemHeight}px`;
                    }

                    // 调整gutter大小
                    if(virtualDiv.clientHeight > tableBody.clientHeight) {
                        this.tableLayout.scrollY = true;
                        this.tableLayout.notifyObservers('scrollable');
                        this.tableLayout.updateColumnsWidth();
                    }else {
                        this.tableLayout.scrollY = false;
                        this.tableLayout.notifyObservers('scrollable');
                        this.tableLayout.updateColumnsWidth();
                    }

                    // 脱离虚拟列表 避免影响高度
                    Object.assign(tableBody.style, {
                        position: 'absolute',
                        left: 0,
                        top: 0
                    });
                });
            });
        },
        handleScroll(event) {
            // console.log('handleScroll', event);
            const scrollTop = event.target.scrollTop;
            this.start = Math.floor(scrollTop / this.itemHeight);
            this.end = this.start + this.visibleCount;
            this.offsetting = scrollTop - (scrollTop % this.itemHeight);
            this.$parent.$el.querySelector(
                '.el-table__body'
            ).style.transform = `translateY(${this.offsetting}px)`;
        },
        scrollTop() {
            const tableBody = this.$parent.$el.querySelector('.el-table__body');
            const scrollContainer = this.$parent.$el.querySelector('.el-table__body-wrapper');
            Object.assign(tableBody.style, {
                transform: 'translateY(0)'
            });
            this.start = 0;
            this.end = this.visibleCount = Math.ceil(
                scrollContainer.clientHeight / this.itemHeight
            );
        }
    }
};
